export class TourStatus {
    name: string;
    id: number;

    constructor() {
        this.name = '';
        this.id = 0;
    }
}